import { render, staticRenderFns } from "./projectDetails.vue?vue&type=template&id=18204b4e&scoped=true&"
import script from "./projectDetails.vue?vue&type=script&lang=js&"
export * from "./projectDetails.vue?vue&type=script&lang=js&"
import style0 from "./projectDetails.vue?vue&type=style&index=0&id=18204b4e&lang=less&scoped=true&"
import style1 from "./projectDetails.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18204b4e",
  null
  
)

export default component.exports